import { SVGProps } from "react";

export const ArrowLeftIcon = ({
  color = "currentColor",
  size = 16,
  strokeWidth = 1,
  ...rest
}: SVGProps<SVGSVGElement> & { size?: number }) => {
  /* Render */
  const render = () => (
    <svg width={size} height={size} {...rest} fill="none" viewBox="0 0 24 24">
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="m5.5 17.5 -5 -5 5 -5"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M0.5 12.5h23"
        strokeWidth={strokeWidth}
      ></path>
    </svg>
  );
  return render();
};
